import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ShieldCheck } from "lucide-react";
import { AIRO } from "@/constants/testIds";

export const NdaModal = ({ open, onOpenChange, nda }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={AIRO.ndaModal}
        className="max-w-2xl bg-[#0a0a0a] border-[#1c1c1c] text-white p-0 gap-0 overflow-hidden"
      >
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-[#161616]">
          <div className="flex items-center gap-3">
            <span className="h-9 w-9 rounded-full bg-cyan-400/10 border border-cyan-400/25 flex items-center justify-center">
              <ShieldCheck className="h-4 w-4 text-cyan-400" />
            </span>
            <div>
              <DialogTitle className="font-heading text-lg text-white">AIROTECH MVP Mutual NDA</DialogTitle>
              <p className="mono-label text-zinc-500 mt-1">
                {nda ? `VERSION ${nda.version} · EFFECTIVE ${nda.effective_date}` : "LOADING…"}
              </p>
            </div>
          </div>
        </DialogHeader>

        <ScrollArea className="h-[55vh] px-6 py-5">
          <pre className="whitespace-pre-wrap font-sans text-sm text-zinc-300 leading-relaxed">
            {nda ? nda.document_content : "Loading the current NDA document…"}
          </pre>
        </ScrollArea>

        <div className="px-6 py-4 border-t border-[#161616] flex justify-end">
          <button
            data-testid={AIRO.ndaModalClose}
            onClick={() => onOpenChange(false)}
            className="mono-label bg-primary text-primary-foreground px-6 py-3 rounded-full hover:bg-[#00b8cc] transition-colors duration-200"
          >
            Close & Return
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
